// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueMessage = (newValue) => ({
  type: actionTypes.SET_VALUE_MESSAGE,
  payload: newValue,
});

export const setStatutMessage = (newValue) => ({
  type: actionTypes.SET_STATUT_MESSAGE,
  payload: newValue,
});
export const setActifMessage = (newValue) => ({
  type: actionTypes.SET_ACTIF_MESSAGE,
  payload: newValue,
});
export const setCurrentPageMessage = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_MESSAGE,
  payload: newCurrentPage,
});

export const setSortFieldMessage = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_MESSAGE,
  payload: newSortField,
});
export const setOrderMessage = (newOrder) => ({
  type: actionTypes.SET_ORDER_MESSAGE,
  payload: newOrder,
});
